<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M1.86361 8.13636C1.51214 7.78489 1.51214 7.21504 1.86361 6.86357C2.21508 6.5121 2.78493 6.5121 3.1364 6.86357L11.5 15.2272L19.8636 6.86357C20.2151 6.5121 20.7849 6.5121 21.1364 6.86357C21.4879 7.21504 21.4879 7.78489 21.1364 8.13636L12.1364 17.1364C11.7849 17.4878 11.2151 17.4878 10.8636 17.1364L1.86361 8.13636Z"
    />
  </svg>
</template>
